export default {"src":"/_next/static/image/public/images/flags/flag_996.4af12d7befa274db9a424e8f2a790dff.svg","height":16,"width":24};